import React, { useEffect, useState } from 'react';
import { ASIAN_HANDICAP } from '../data/constants';
import { getAnimationDuration } from '../data/utils/getAnimationDuration';
import { getConfiguration } from '../data/utils/configuration';
import { getOutcomeSpread } from '../data/utils/getOutcomeSpread';
import { getToolTipDesc } from '../data/utils/getToolTipDesc';
import { showMatchDesc } from '../data/utils/showMatchDesc';
import OddWrapper from './OddWrapper';

function InnerOdd(props) {
    const conf = getConfiguration();
    
    const [oddValue, setOddValue] = useState(props.value);
    const [oddClass, setOddClass] = useState('');

    const [timeoutInterval] = useState(getAnimationDuration());

    useEffect(() => {
        let timeout = null;
        if (props.value !== oddValue) {
            setOddValue(props.value);
            if (props.betData.isLive) {
                let classValue = null;
                if (!props.value) {
                    classValue = '';
                } else if(props.value > oddValue) {
                    classValue = ' quota-aumentata';
                } else if(props.value < oddValue) {
                    classValue = ' quota-diminuita';
                }
                setOddClass(classValue);
                if (timeout) {
                    clearTimeout(timeout);
                }
                timeout = setTimeout(() => {
                    setOddClass('');
                }, timeoutInterval);
            }
        }
        return () => {
            clearTimeout(timeout);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.value]);
    
    let classes = '';
    if (props.selected) {
        classes += ' bet-selected';
    } else if (props.highlighted) {
        classes += ' odd-highlighted';
    } else if (props.disabled) {
        classes += ' odd-disabled';
    }
    if (props.betData.pClass != null) {
        classes += ' ' + props.betData.pClass;
    }
    classes += oddClass;

    let desc = props.desc, addSpread = false;
    if (props.betData.hideHandicap) {
        desc = `${props.betData.desc} ${props.desc}`;
    } else {
        let dia = props.dia ? props.dia : props.betData.dia;
        const outcomeSpread = getOutcomeSpread(props.betData.handicap, props.betData.tipoHandicap, null, dia);
        // Caso ':' è per visualizzare scommesse estere ad handicap
        addSpread = !props.isFromCompactBet && outcomeSpread !== '' && outcomeSpread !== '0' && ![5, 7, 40].includes[props.betData.tipoHandicap] && !props.compactView && desc && desc.indexOf(':') === -1 && !(conf.nas && ASIAN_HANDICAP.includes(props.betData.id));
        if (addSpread) {
            desc = `${desc}  (${outcomeSpread})`;
        }
    }

    return (
        <>
            {props.showMatchDesc ?
                <div className={"esito" + classes} onClick={props.onClick}>
                    <span className="nome-esito text-small">{props.desc}</span>
                    <hr />
                    {props.value != null ?
                        <span className="quota-esito text-small">{oddValue}</span>
                        :
                        <span className="quota-esito text-small">&#128274;</span>
                    }
                </div>
                :
                <div className={"esito" + classes} onClick={props.onClick}>
                    <span className="nome-esito text-small">{desc}</span>
                    <hr />
                    {props.value != null ?
                        <span className="quota-esito text-small">{oddValue}</span>
                        :
                        <span className="quota-esito text-small">&#128274;</span>
                    }
                </div>
            }
        </>
    );
}

function Odd(props) {
    const isShowMatchDesc = !props.isLastMinute && showMatchDesc(props);
    let desc = props.desc;
    if (isShowMatchDesc && props.tooltip) {
        desc = getToolTipDesc(props);
    }
    return <OddWrapper {...props} desc={desc} showMatchDesc={isShowMatchDesc} render={InnerOdd} />;
}

export default Odd;
